module.exports = __webpack_public_path__ + "img/page8.8585e3c9.jpeg";